// extracted by mini-css-extract-plugin
export default {"center_box":"FileUpload_center_box__6wayi","input":"FileUpload_input__Z4Kh8","upload_button":"FileUpload_upload_button__9IYgK","error_text":"FileUpload_error_text__J9BDE"};